import axiosInstance from "../../services/axiosInstance";

export const addCurrency = async (currencyData: any) => {
    try {
        const response = await axiosInstance.post('/exchange-rate', currencyData);
        console.log("Currency added successfully:", response.data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getAllCurrencies = async () => {
    try {
        const response = await axiosInstance.get('/exchange-rate');
        return response.data;
    } catch (error) {
        throw error;
    }
};